<div class="search-item">
  <div class="parents tui-text_body-xs">
    {{ data.parents }}
    </div>
    <div class="search-item__content">
      <tui-checkbox
        [(ngModel)]="checkbox"
        (ngModelChange)="onChecked($event)"
        class="search-item__checkbox"
      ></tui-checkbox>
      <div>{{data ? data.value : ''}}</div>
    </div>
</div>
